import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  employeeSurveySubmissionReplyId: string;
};

type MessageWithIdType = ResponseMessageType & {
  id: string;
};

const request = ({ employeeSurveySubmissionReplyId }: RequestDataType) => {
  return new ApiClient()
    .post<MessageWithIdType>(
      `/api/members/employee_survey_submission_replies/${employeeSurveySubmissionReplyId}/likes`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersEmployeeSurveySubmissionRepliesLikesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<MessageWithIdType, RequestDataType> => {
  return useMutation(request, { ...options });
};
